import http from "infra/http";
import { useMutation } from "react-query";
import { UnidadeUnificadaForm } from "../typings";

function useSaveUnidadeUnificada(id?: string) {
  return useMutation(
    `/v1/bloqueio-reserva`,
    (data: UnidadeUnificadaForm) =>
      id
        ? http.put(`/v1/unidades-unificadas/${id}`, data)
        : http.post(`/v1/unidades-unificadas`, data),
    { retry: false }
  );
}

export default useSaveUnidadeUnificada;
